exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.banner{background-color:#4bb543;color:#fff;display:flex;height:50px;width:100%;text-align:center;white-space:nowrap;transition-property:all;transition-duration:.5s;transition-timing-function:cubic-bezier(0,1,.5,1);position:absolute;top:0}.banner--closing{top:-50px}.banner__text{display:flex;font-family:Open Sans,sans-serif;line-height:26px;font-size:24px;font-weight:600;margin:12px auto;white-space:pre}.banner__text a{color:#fff}.banner__close{cursor:pointer;font-size:32px;margin-right:12px;margin-top:5px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/banners/AnnouncementBanner/AnnouncementBanner.scss
// module id = 1687
// module chunks = 0